import { StringHelper } from '@act/shared/utilities';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Typography } from '@mui/material';
import styled from 'styled-components';

export const DialogContentContainer = styled.div`
  padding: 0;
`;

export const DialogTitleBar = styled.div`
  padding: 14px 24px;
`;

export const DialogFormFieldWrapper = styled.div`
  padding: 8px 0px 16px 0px;
`;

export const DialogFormFieldWrapperShort = styled.div`
  padding: 8px 0px;
`;

export const CloseButton = styled(IconButton)`
  position: absolute !important;
  right: 16px;
  top: 8px;
`;

export const SplitRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: baseline;

  & > div {
    flex: 1 1 auto;
  }
`;

export function normalizeType(type: string) {
  return StringHelper.sentenceCase(
    type === null || type === 'not found' ? 'Unknown' : type
  );
}

interface DialogTitleBarComponentProps {
  title: string;
  handleClose?: () => void;
}

export const DialogTitleBarComponent = ({
  title,
  handleClose,
}: DialogTitleBarComponentProps) => {
  return (
    <DialogTitleBar>
      <Typography variant="titleLarge">{title}</Typography>
      {handleClose && (
        <CloseButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      )}
    </DialogTitleBar>
  );
};
